var ElementsHandler;

ElementsHandler = function( $ ) {
	var self = this;

	// element-type.skin-type
	var handlers = {
		// Elements
		'section': require( 'kitbuilder-frontend/handlers/section' ),

		// Widgets
		'accordion.default': require( 'kitbuilder-frontend/handlers/accordion' ),
		'alert.default': require( 'kitbuilder-frontend/handlers/alert' ),
		'counter.default': require( 'kitbuilder-frontend/handlers/counter' ),
		'progress.default': require( 'kitbuilder-frontend/handlers/progress' ),
		'tabs.default': require( 'kitbuilder-frontend/handlers/tabs' ),
		'toggle.default': require( 'kitbuilder-frontend/handlers/toggle' ),
		'video.default': require( 'kitbuilder-frontend/handlers/video' ),
		'image-carousel.default': require( 'kitbuilder-frontend/handlers/image-carousel' ),
		'text-editor.default': require( 'kitbuilder-frontend/handlers/text-editor' )
	};

	var addGlobalHandlers = function() {
		kitbuilderFrontend.hooks.addAction( 'frontend/element_ready/global', require( 'kitbuilder-frontend/handlers/global' ) );
		kitbuilderFrontend.hooks.addAction( 'frontend/element_ready/widget', require( 'kitbuilder-frontend/handlers/widget' ) );
	};

	var addElementsHandlers = function() {
		$.each( handlers, function( elementName, funcCallback ) {
			kitbuilderFrontend.hooks.addAction( 'frontend/element_ready/' + elementName, funcCallback );
		} );
	};

	var runElementsHandlers = function() {
		var $elements;

		if ( kitbuilderFrontend.isEditMode() ) {
			// Elements outside from the Preview
			$elements = kitbuilderFrontend.getScopeWindow().jQuery( '.kitbuilder-element', '.kitbuilder:not(.kitbuilder-edit-mode)' );
		} else {
			$elements = $( '.kitbuilder-element' );
		}

		$elements.each( function() {
			self.runReadyTrigger( $( this ) );
		} );
	};

	var init = function() {
		if ( ! kitbuilderFrontend.isEditMode() ) {
			self.initHandlers();
		}
	};

	this.initHandlers = function() {
		addGlobalHandlers();

		addElementsHandlers();

		runElementsHandlers();
	};

	this.getHandlers = function( handlerName ) {
		if ( handlerName ) {
			return handlers[ handlerName ];
		}

		return handlers;
	};

	// TODO: Temp fallback method from 1.2.0
	this.addExternalListener = function( $scope, event, callback, externalElement ) {
		kitbuilderFrontend.addListenerOnce( $scope.data( 'model-cid' ), event, callback, externalElement );
	};

	this.runReadyTrigger = function( $scope ) {
		var elementType = $scope.attr( 'data-element_type' );

		if ( ! elementType ) {
			return;
		}

		kitbuilderFrontend.hooks.doAction( 'frontend/element_ready/global', $scope, $ );

		var isWidgetType = ( -1 === [ 'section', 'column' ].indexOf( elementType ) );

		if ( isWidgetType ) {
			kitbuilderFrontend.hooks.doAction( 'frontend/element_ready/widget', $scope, $ );
		}

		kitbuilderFrontend.hooks.doAction( 'frontend/element_ready/' + elementType, $scope, $ );
	};

	init();
};

module.exports = ElementsHandler;
